import * as types from 'constants/ActionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {boolean} */
const initialState = false;

const isLoading = () => true;

const isEnding = () => false;

export default createReducer(initialState, {
  [types.FETCH_STATISTICS_INTERVENTION_BRANDS_REQUEST]: isLoading,
  [types.FETCH_STATISTICS_INTERVENTION_BRANDS_FAILURE]: isEnding,
  [types.FETCH_STATISTICS_INTERVENTION_BRANDS_SUCCESS]: isEnding,
});
